var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSevere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2580_14434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 31,
    width: 101,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6171 31.6599C75.9933 30.9527 77.0067 30.9527 77.3829 31.6599L126.381 123.78C126.735 124.446 126.252 125.25 125.498 125.25H27.5021C26.7476 125.25 26.2649 124.446 26.6192 123.78L75.6171 31.6599Z",
    fill: "#D8B4B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2580_14434)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 97,
    transform: "translate(25 30)",
    fill: "#C60031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2011 63.4963C71.0912 60.4938 73.4955 58 76.5 58V58C79.5045 58 81.9088 60.4938 81.7989 63.4963L80.6462 95.0027C80.5646 97.2336 78.7324 99 76.5 99V99C74.2676 99 72.4354 97.2336 72.3538 95.0027L71.2011 63.4963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 105,
    width: 11,
    height: 12,
    rx: 5.5,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.618 14.6507C75.9947 13.9457 77.0053 13.9457 77.382 14.6507L140.233 132.279C140.589 132.945 140.106 133.75 139.351 133.75H13.6492C12.894 133.75 12.4113 132.945 12.7672 132.279L75.618 14.6507Z",
    stroke: "#C60031",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevere);
export default __webpack_public_path__ + "static/media/severe.4b3732c7edc33f673f06ad0a5a85b4a4.svg";
export { ForwardRef as ReactComponent };